import React from "react"
import "./styles.css"
import {
    getsSkillCooldown,
    getSkillCast,
} from "../../../services/UpdateDisplayData"

const SkillLevelInfo = (props) => {
    const { indexLevel, maxLevel, displayLevel, characterCooldown } = props
    return (
        <div className="level-container">
            <span>
                Nível atual: {indexLevel + 1}/{maxLevel}
            </span>
            <span>
                Resfriamento:{" "}
                {getsSkillCooldown(characterCooldown, displayLevel.cooldown)} segundos
            </span>
            <span>MP consumido: {displayLevel.mp}</span>
            <span>Tempo de cast: {getSkillCast(displayLevel.cast)}</span>
            <span>Descrição: {displayLevel.info}</span>
        </div>
    )
}

export default React.memo(SkillLevelInfo)
